export default __webpack_public_path__ + "static/media/binance-wallet.60053316.png";